import { Grid, GridProps } from "@mui/material";
import React from "react";
interface MxFormLayoutProps extends GridProps {
  children: React.ReactNode;
}
const MxListLayoutBody = (props: MxFormLayoutProps) => {
  return (
    <Grid
      container
      sx={{
        p: {
          xs: 1,
          md: 2
        }
      }}
      {...props}
    >
      {props.children}
    </Grid>
  );
};

export default MxListLayoutBody;
